import React, { useState } from 'react';
import Header from './Header';
import Breadcrumb from './Breadcrumb';
import Sidebar from './Sidebar';
import OrderDetails from './OrderDetails';

const OrderDetailsReturned = () => {
  const [deviceSize, setDeviceSize] = useState(() => "large");
  const [location, setLocation] = useState(() => ({
    query: {},
    path: "",
  }));

  // Sample order data - this can be passed as props or fetched from API
  const orderData = {
    orderInfo: {
      orderId: '#ORD57986418741',
      orderedAt: '26 May, 2023 09:30 PM',
      status: 'Returned',
      payment: 'Card'
    },
    deliveryAddress: {
      name: 'Jaane Cooper',
      address: '4517 Washington Ave. Manchester, Kentucky Preston Rd. Inglewood, 987456',
      phone: '+1 888 3685 368'
    },
    items: [
      {
        id: 1,
        name: 'Loveable for someone Teddy Bear',
        quantity: 1,
        status: 'Returned',
        image: 'https://cdn.acsdev.in/Rentastic/2.png'
      },
      {
        id: 2,
        name: 'Loveable for someone Teddy Bear',
        quantity: 1,
        status: 'Returned',
        image: 'https://cdn.acsdev.in/Rentastic/3.png'
      }
    ],
    orderSummary: {
      premiumChargeLabel: 'Premium toys charge',
      premiumCharge: '$30.00',
      shippingChargeLabel: 'Shipping charge',
      shippingCharge: '$10.00',
      discountLabel: 'Discount',
      discountSubLabel: '(Premium toys)',
      discount: '-$10.00',
      total: '$20.00'
    },
    actions: [
      {
        label: 'Rate & Review',
        primary: false,
        onClick: () => console.log('Rate & Review clicked'),
        ariaLabel: 'Rate and review this order'
      },
      {
        label: 'Repeat Order',
        primary: false,
        onClick: () => console.log('Repeat Order clicked'),
        ariaLabel: 'Repeat this order'
      },
      {
        label: 'Purchase Permanently',
        primary: true,
        onClick: () => console.log('Purchase Permanently clicked'),
        ariaLabel: 'Purchase items permanently'
      }
    ]
  };

  return (
    <div className="flex overflow-hidden flex-col pb-96 bg-neutral-50 max-md:pb-24">
      <Header />

      <div className="flex flex-col self-center mt-6 w-full max-w-[1140px] max-md:max-w-full">
        <Breadcrumb orderId={orderData.orderInfo.orderId} />

        <div className="mt-7 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col">
            <div className="w-[27%] max-md:ml-0 max-md:w-full">
              <Sidebar />
            </div>

            <div className="ml-5 w-[73%] max-md:ml-0 max-md:w-full">
              <OrderDetails orderData={orderData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsReturned;
